export default __webpack_public_path__ + "static/media/result-panel-picture.ab41a548.png";